<template>
	<div>
		<div class="section section-history">
			<div class="section-title is-small">
				History
			</div>
			<div
				v-if="!hasHistory"
				class="empty-dashboard"
			>
				<div class="section-subtitle is-small is-white">
					😔 You still haven't created your first link
				</div>
				<div class="section-description is-medium">
					<u>Create it now</u> and it will appear here
				</div>
			</div>
			<div
				v-if="hasHistory"
				class="items"
			>
				<ul>
					<li
						v-for="item in historyList"
						:key="item.Id"
						class="link-element"
						@click="editLink(item)"
					>
						<div class="section-subtitle">
							{{ item.Title }}
						</div>
						<div class="section-items">
							<div class="copy-link">
								{{ item.FullURL }}
								<AppButton
									size="flex"
									color="none"
									class="button"
									@click.stop="onCopy(item.FullURL)"
								>
									<img
										src="@/assets/copy.png"
										alt="copy"
									>
								</AppButton>
							</div>
							<div class="section-description is-thin">
								{{ item.CountClicks }} clicks
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'WidgetHistory',

	components: {
		AppButton,
	},

	computed: {
		...mapGetters([
			'historyList',
		]),
		hasHistory() {
			return this.historyList.length > 0;
		},
	},

	mounted() {
		this.fetchHistory();
	},

	methods: {
		...mapActions([
			'fetchHistory',
			'deleteLink',
			'updateLink',
			'setLinkToEdit',
		]),
		onCopy(url) {
			this.$copyText(url).then(
				(success) => {
					this.$notify({
						duration: 6000,
						type: 'info',
						title: '',
						text: `You copied the shortlink ${success.text}`,
					});
				},
				() => {
					this.$notify({
						duration: 6000,
						type: 'error',
						title: 'FAILED',
						text: 'An error has occurred. Please contact support or copy the link manually.',
					});
				},
			);
		},
		editLink(link) {
			this.setLinkToEdit(link);
		},
	},
};
</script>

<style lang="scss" scoped>
.section-history {
	max-height: 614px;
	display: flex;
	flex-direction: column;
	position: relative;
	margin-right: $gap-2;
}

.section-title {
	margin-bottom: $gap-3;
}

.empty-dashboard {
	margin: $gap-5 0;

	.section-description {
		margin-top: $gap-1;
	}
}

.no-button {
	border: none;
	background-color: transparent;
	cursor: pointer;
}

.items {
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: $gap-4;

	.section-subtitle {
		font-size: $size-6;
		color: $color-white;
		word-wrap: nowrap;
		margin: $gap-1 0;
	}

	.section-description {
		font-size: $size-7;
		font-weight: $fontWeight-semibold;
		display: flex;
		align-items: center;
		color: $color-accent-300;

		&.is-thin {
			font-weight: $fontWeight-regular;
		}

		img {
			margin-left: $gap-1;
		}
	}

	.section-items {
		display: flex;
		justify-content: space-between;
		padding-bottom: $gap-25;
		border-bottom: 1px solid $color-accent-400;
	}

	ul {
		li {
			padding: $gap-1 0;
		}
	}
}

.copy-link {
	display: flex;
	align-items: center;
	cursor: text;

	div {
		margin-right: $gap-1;
	}
}

.link-element {
	cursor: pointer;

	&:hover {
		.section-subtitle {
			color: $color-primary;
		}
	}
}
</style>
